import { render, staticRenderFns } from "./section-item.vue?vue&type=template&id=b41ffec6&scoped=true"
import script from "./section-item.vue?vue&type=script&lang=js"
export * from "./section-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b41ffec6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b41ffec6')) {
      api.createRecord('b41ffec6', component.options)
    } else {
      api.reload('b41ffec6', component.options)
    }
    module.hot.accept("./section-item.vue?vue&type=template&id=b41ffec6&scoped=true", function () {
      api.rerender('b41ffec6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/dashboard-design/charts/section/section-item.vue"
export default component.exports